module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="photoInputForm">\n    <div>\n        <label class="photoInputFormLabel newPhotoLabelPosition" for="albumFormTitle">Titre</label>\n        <input class="photoInputFormInput titleInput formInput" type="text" id="albumFormTitle" name="title"><br>\n    </div>\n</div>';

}
return __p
}